<template lang="html">
  <div class="radio-linear d-inline-block py-2">
    <template v-for="(opt, index) in options" >
      <div
        :key="`rl_${index}`"
        class="mpv-radio-blue radio from-check form-check-inline mx-3">
        <input
          @change="handleChange"
          type="radio"
          class="form-check-input"
          :name="name"
          :checked="opt.value === value"
          :value="opt.value">
        <span class="checkmark"><span></span></span>
        <label
          v-html="opt.label"
          class="form-check-label pl-4">
        </label>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  props: {
    options: Array,
    name: String,
    value: String | Boolean | Number
  },

  methods: {
    handleChange ($event) {
      this.$emit('change', $event.target.value)
    }
  }
}
</script>

<style lang="scss">
  @import '../../../scss/colors';

  .radio-linear {
    .mpv-radio-blue {
      position: relative;
      width: max-content;
      flex: 1 0 auto;

      & .checkmark {
        position: absolute;
        top: auto;
        bottom: auto;
        left: 0;
        height: 1rem;
        width: 1rem;
        background-color: transparent;
        border: solid 1px $secondary;

        & span {
          position: absolute;
          top: 0;
          bottom: 0;
          left: 0;
          right: 0;
          height: 100%;
          width: 100%;
          border: solid 4px $cyan;
          opacity: 0;
        }
      }

      & .checkmark, span {
        border-radius: 0;
      }

      &.radio .checkmark, span {
        border-radius: 50%;
      }

      & input {
        opacity: 0;
        z-index: 1;
        cursor: pointer;
        position: absolute;
        width: 100%;
      }

      & input:disabled ~ .checkmark {
        opacity: 0.5;
      }

      & input:checked ~ .checkmark {
        border-radius: 0;

        & span {
          opacity: 1;
          border-radius: 0;
        }
      }

      &.radio input:checked ~ .checkmark {
        border-radius: 50%;
        border: none;

        & span {
          border-radius: 50%;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/ui/forms/RadioLinear.vue